import { apiRequest } from "../../util/apiUtils";


export const getPageData = async (params) => {
    try {
      const res = await apiRequest(
        "get",
        `common/pageDetails/${params?.slug}`,
        {}
      );
  
      return res.data;
    } catch (err) {
      return err?.response;
    }
  };